import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, EmptyState, Icon } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'

interface BeneficiaryErrorStateProps {
  onRefresh: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
}

export const BeneficiaryErrorState = ({ onRefresh }: BeneficiaryErrorStateProps) => {
  const { t } = useTranslation()

  return (
    <EmptyState
      testId="error-state"
      LottiePlayer={<Lottie src="connection-error" />}
      title={t('oopsSomethingWentWrongContracted')}
      description={t('reloadPage')}
      PrimaryButton={
        <Button iconElement={<Icon name="ArrowsClockwise" />} onClick={onRefresh}>
          {t('refresh')}
        </Button>
      }
    />
  )
}
